<app-uni-page [parent]="this" pageTitle="Return Requests" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"> </app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter *ngIf="isPageReady" class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <div class="w-3/4 grow">
          <app-ag-grid [gridOptions]="rrGridOptions"></app-ag-grid>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="flex flex-row w-full h-full overflow-hidden">
        <!-- Left side: vertically stacked buttons -->
        <div class="flex flex-col gap-2 shrink-0 mr-4 mt-12">
          <button
            [disabled]="!canPrintAnyItemDetailBarcodes()"
            pButton
            type="button"
            class="p-button-raised p-button-sm"
            (click)="printAllItemDetailBarcodes()"
          >
            <span>Print Barcodes for Returned Items</span>
          </button>
          <button
            [disabled]="!canPrintAnyRepairBarcodes()"
            pButton
            type="button"
            class="p-button-raised p-button-sm"
            (click)="printAllRepairBarcodes()"
          >
            <span>Print Barcodes for Repair Items</span>
          </button>
        </div>
        <!-- Right side: title and grid -->
        <div class="flex flex-col w-full min-h-0">
          <div class="qb-child-actions shrink-0">
            <span class="font-semibold">Return Request Details</span>
          </div>
          <app-ag-grid [gridOptions]="rrdGridOptions" [rowData]="returnRequestDetails" class="flex-1 min-h-0"></app-ag-grid>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
